import React, { useEffect } from 'react';
import { MapPin, Plane, Trophy } from 'lucide-react';
import TopBar from '../components/TopBar';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const facts = [
  { icon: MapPin, label: 'DESTINO', value: 'Malásia' },
  { icon: Trophy, label: 'EXPEDIÇÃO', value: 'Connection Darts — Vencedores Nível 3' },
  { icon: Plane, label: 'TEMPORADA', value: '2026' },
];

export default function Torneios() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Torneios Internacionais — Malásia 2026 | Square Darts';
  }, []);

  return (
    <div className="App min-h-screen bg-[color:var(--sd-bg)]" data-testid="torneios-page">
      <TopBar />
      <Navbar />
      <section className="relative w-full pt-40 pb-24 md:pt-44 md:pb-32">
        <div className="max-w-6xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-[1.1fr_0.9fr] gap-12 lg:gap-16 items-start">
          <div>
            <div className="text-[10px] tracking-[0.35em] text-[color:var(--sd-cyan)]/70 font-mono mb-4">
              // TORNEIOS_INTERNACIONAIS.EXE
            </div>
            <h1 data-testid="torneios-title" className="font-display font-black text-white text-3xl sm:text-5xl lg:text-6xl tracking-widest leading-tight">
              TORNEIOS <span className="text-[color:var(--sd-cyan)] sd-glow">INTERNACIONAIS</span>
            </h1>
            <h2 data-testid="torneios-subtitle" className="mt-6 font-display text-[color:var(--sd-cyan)] text-base md:text-lg tracking-[0.3em]">
              MALÁSIA 2026
            </h2>
            <p className="mt-6 font-mono text-[color:var(--sd-text)]/85 leading-relaxed max-w-xl">
              A Square Darts esteve presente na Expedição Malásia da Connection Darts,
              ao lado dos vencedores do Nível 3. Acompanhe a viagem, os bastidores e
              a energia dos jogadores rumo à competição internacional.
            </p>
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
              {facts.map(({ icon: Icon, label, value }) => (
                <div key={label} className="sd-panel p-5" data-testid={`torneios-fact-${label.toLowerCase()}`}>
                  <Icon size={18} className="text-[color:var(--sd-cyan)]" />
                  <div className="mt-3 text-[10px] tracking-[0.3em] text-[color:var(--sd-muted)] font-mono">{label}</div>
                  <div className="mt-1 font-mono text-sm text-white">{value}</div>
                </div>
              ))}
            </div>
            <a href="/#distribuidor" data-testid="torneios-cta-btn" className="sd-btn mt-10 inline-flex">
              QUERO FAZER PARTE
            </a>
          </div>
          <div className="sd-panel sd-brackets p-3 mx-auto w-full max-w-[380px]">
            <video
              data-testid="torneios-video"
              className="w-full aspect-[9/16] object-cover bg-black"
              src="/videos/malaysia-2026.mp4"
              poster="/videos/malaysia-2026-poster.jpg"
              controls
              playsInline
              preload="metadata"
            />
            <div className="mt-3 text-[10px] tracking-[0.3em] text-[color:var(--sd-cyan)]/80 font-mono text-center">
              EXPEDIÇÃO MALÁSIA // 2026
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
